import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";
import { default as MUIIconSave } from "@mui/icons-material/Save";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import Typography from "@mui/material/Typography";

import { RouterLink } from "src/routes/components";
import Iconify from "src/components/iconify";
import axios_api from "src/api/axios";
import { Box, Grid, Skeleton } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CustomSelect from "src/components/form-field/custom-select";
import { prompt } from "src/utils/prompt";
import { dateFormatter } from "src/utils/date-formatter";

// ----------------------------------------------------------------------

export default function StaticUrlsDetail() {
  const params_ = useParams();
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState(null);
  const navigate = useNavigate();
  const instance_id = params_.id ? params_.id : false;
  const instance_operation = instance_id ? "update" : "create";

  const loadRecord = async () => {
    try {
      setLoading(true);
      const response = await axios_api.get(
        `/web-source-url/manage/${instance_id}/details/`
      );
      if (response.data["result"] === "success") {
        instanceFormik.setValues(response.data["record"]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      prompt.error("Error loading record");
    }
  };

  const loadInstanceSchema = (instance_operation) => {
    const instanceSchema = Yup.object().shape({
      status_id: Yup.string().trim().required("Status is required"),
    });
    return instanceSchema;
  };

  const instanceFormik = useFormik({
    initialValues: {
      name: "",
      emai: "",
      status_id: 8,
      status: "",
      created_at: "",
      message: "",
    },
    enableReinitialize: true,
    validationSchema: loadInstanceSchema(instance_operation),
    onSubmit: async (values, actions) => {
      await axios_api
        .post(`get-in-touch/status/manage/${instance_id}/`, {
          status_id: values.status_id,
        })
        .then(({ data }) => {
          if (data["result"] === "success") {
            prompt.formDataSuccess({
              action: instance_operation,
              item: "Dealer Enquiry Status",
              navigate: () => navigate("/dealer-enquiry/"),
              loadRecord: loadRecord,
            });
          }
        })
        .catch((error) => {
          prompt.error("unable to update status");
        });
    },
  });

  async function getStatusList() {
    try {
      const { data } = await axios_api.get("get-in-touch/status/listing/");
      if (data["result"] === "success") {
        setStatusList(data["records"]);
      }
    } catch (error) {
      prompt.error("unable to fetch status list");
    }
  }

  useEffect(() => {
    if (instance_id) {
      loadRecord();
    }
    getStatusList();
    //eslint-disable-next-line
  }, [instance_id]);

  const renderData = (
    <Stack direction="column" spacing={1.5}>
      <Box>
        <Typography variant="subtitle2">Name</Typography>
        <Typography variant="body2">{instanceFormik?.values?.name}</Typography>
      </Box>
      {/* <Box>
        <Typography variant="subtitle2">Enquiry</Typography>
        <Typography variant="body2">
          {instanceFormik?.values?.message}
        </Typography>
      </Box> */}
      <Box>
        <Typography variant="subtitle2">Group</Typography>
        <Typography variant="body2">{instanceFormik?.values?.group}</Typography>
      </Box>
      <Box>
        <Typography variant="subtitle2">Is Active</Typography>
        <Typography variant="body2">
          {instanceFormik?.values?.is_active == true ? "Yes" : "No"}
        </Typography>
      </Box>
      <Box>
        <Typography variant="subtitle2">Created On</Typography>
        <Typography variant="body2">
          {dateFormatter(instanceFormik?.values?.created_at)}
        </Typography>
      </Box>
    </Stack>
  );
  const renderLoading = (
    <Stack direction="column" spacing={1.5}>
      <Box>
        <Skeleton variant="text" width={100}></Skeleton>
        <Skeleton variant="text" width={200}></Skeleton>
        <Skeleton variant="text" width={200}></Skeleton>
      </Box>
      <Box>
        <Skeleton variant="text" width={100}></Skeleton>
        <Skeleton variant="text"></Skeleton>
        <Skeleton variant="text"></Skeleton>
        <Skeleton variant="text"></Skeleton>
        <Skeleton variant="text"></Skeleton>
      </Box>
      <Box mb={2}>
        <Skeleton variant="text" width={100}></Skeleton>
        <Skeleton variant="text" width={150}></Skeleton>
      </Box>
    </Stack>
  );

  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4">Static URL</Typography>
        <Button
          variant="contained"
          component={RouterLink}
          href="/static-urls/"
          color="inherit"
          startIcon={<Iconify icon="eva:home-fill" />}
        >
          Static URL's
        </Button>
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Card
          sx={{
            p: 5,
            width: 1,
          }}
        >
          {loading ? renderLoading : renderData}
        </Card>
      </Stack>
    </Container>
  );
}
